import { render, staticRenderFns } from "./sectionPay.vue?vue&type=template&id=47f1d26f&scoped=true"
import script from "./sectionPay.vue?vue&type=script&lang=js"
export * from "./sectionPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1d26f",
  null
  
)

export default component.exports